<script setup lang="ts">
import { isProblem, isValidation } from '@kodall/kodall-client/dist/types';
import type { DropdownMenuItem } from '@nuxt/ui'

const props = defineProps<{
  collapsed?: boolean
}>()

const client = useAccount().account

const kc = useSecurity().kc
const userName = ref<string>()
const s = useSecurity()
const account = useAccount();
const search_name = ref()
const session = async () => s.kc.value.session({roles: true})
const result = await session()
if(!isProblem(result)) {
  userName.value = result.userName
}

const user = ref({
  email: userName.value,
  avatar: {
    src: '/user.png',
    alt: search_name.value,
  }
})

onMounted(async () => {
  if(account.account.value?.id_client) {
    const client = await kc.value.get('client', account.account.value?.id_client)
    if(isProblem(client) || isValidation(client)) return
    search_name.value = client.properties.search_name
  }
  else if(account.account.value?.id_operator) {
    const operator = await kc.value.get('operator', account.account.value?.id_operator)
    if(isProblem(operator) || isValidation(operator)) return
    search_name.value = operator.properties.name
  }

  user.value.avatar.alt = search_name.value
})



const items = computed<DropdownMenuItem[]>(() => [
  {
    type: 'label',
    label: user.value.avatar.alt,
    avatar: user.value.avatar,
    email: user.value.email,
  },
  // not implemented
  // { type: 'separator' },
  // {
  //   label: 'Schimbă parola',
  //   icon: 'i-lucide-key-round',
  //   to: '/schimba-parola',
  // },
  { type: 'separator' },
  {
    label: 'Ieși din cont',
    icon: 'i-lucide-log-out',
    onSelect: () => s.logout(),
  }
])
</script>

<template>
  <UDropdownMenu
    :items="items"
    :content="{ align: 'center', collisionPadding: 12 }"
    :ui="{
    content: 'w-fit',
    item: 'text-base font-medium'
  }"
  >
    <UUser :avatar="user.avatar" size="lg" />

    <template #item="{ item }">
      <div
        v-if="item.type === 'label'"
        class="flex flex-col items-center text-center"
      >
        <UAvatar
          :src="item.avatar?.src"
          :alt="item.avatar?.alt"
          size="xl"
          class="mb-2"
        />
        <div class="font-semibold text-base text-slate-950">
          {{ item.avatar?.alt }}
        </div>
        <div class="font-normal text-sm text-slate-950">
          {{ item.email}}
        </div>
      </div>


    </template>
  </UDropdownMenu>
</template>
